var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100vw" }, attrs: { id: "bloque1" } },
    [
      _c("div", { staticClass: "loginBox" }, [
        _c("img", {
          staticClass: "loginBoxImg",
          attrs: { src: "/dist/logo-login.png" }
        }),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "labels",
            staticStyle: {
              "font-weight": "400",
              "font-size": "20px",
              "margin-bottom": "20px"
            },
            attrs: { id: "titulo" }
          },
          [_vm._v("Cambiar contraseña")]
        ),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("p", { staticClass: "labels" }, [_vm._v("CONTRASEÑA ACTUAL")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.passActual,
                  expression: "passActual"
                }
              ],
              staticClass: "inputBox",
              class: { inputBoxInv: _vm.errorPassActual },
              attrs: { type: "password" },
              domProps: { value: _vm.passActual },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.passActual = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "labels" }, [_vm._v("NUEVA CONTRASEÑA")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.passNueva,
                  expression: "passNueva"
                }
              ],
              staticClass: "inputBox",
              class: { inputBoxInv: _vm.errorPassNueva },
              attrs: { type: "password" },
              domProps: { value: _vm.passNueva },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.passNueva = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "labels" }, [
              _vm._v("REPITA NUEVA CONTRASEÑA")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.repPassNueva,
                  expression: "repPassNueva"
                }
              ],
              staticClass: "inputBox",
              class: { inputBoxInv: _vm.errorRepPassNueva },
              attrs: { type: "password" },
              domProps: { value: _vm.repPassNueva },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.repPassNueva = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticStyle: { height: "15px" } }, [
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.errorPassActual ||
                        _vm.errorPassNueva ||
                        _vm.errorRepPassNueva,
                      expression:
                        "errorPassActual || errorPassNueva || errorRepPassNueva"
                    }
                  ],
                  staticClass: "labels error"
                },
                [_vm._v(_vm._s(_vm.errorMsg))]
              )
            ]),
            _vm._v(" "),
            _c("div", { attrs: { id: "btnContainer" } }, [
              _c(
                "button",
                {
                  attrs: { id: "btnRegistro" },
                  on: { click: _vm.btnCancelar }
                },
                [_vm._v("CANCELAR")]
              ),
              _vm._v(" "),
              _c(
                "button",
                { attrs: { id: "btnIngresar" }, on: { click: _vm.btnCambiar } },
                [_vm._v("CAMBIAR")]
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b3ee888", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b3ee888","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/configuracion.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6b3ee888","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/configuracion.vue
// module chunks = 0